import '../style/exam-result/ER_Chart2.css';
import { Bar } from 'react-chartjs-2';

const data = {
  labels: ['ریاضی', 'فلسفه', 'منطق', 'مبانی موسیقی', 'برنامه‌نویسی'],
  datasets: [
    {
      label: 'درصد شما',
      data: [50, 80, 70, 60, 70],
      backgroundColor: '#2E81E8',
      barPercentage:0.5,
      borderRadius:3
    },
    {
      label: 'میانگین درصد آزمون',
      data: [20, 5, 10, 10, 10],
      backgroundColor: '#58F4FA',
      barPercentage:0.5,
      borderRadius:3
    },
  ],
};

const options = {
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
  plugins:{
    legend:{
      display:false
    }
  }
};


const ER_Chart2=()=>{
  return(
    <div className="er-chart2">
      <div className="er-chart2-title">نمودار شماره 1</div>
       <div className="er-chart2-guide">
         <div className="er-chart2-guide-box">
           <div className="er-chart2-guide-box-circle1"></div>
           <div className="er-chart2-guide-box-text1">درصد شما</div>
         </div>
         <div className="er-chart2-guide-box">
           <div className="er-chart2-guide-box-circle2"></div>
           <div className="er-chart2-guide-box-text2">میانگین درصد آزمون</div>
         </div>
       </div>
      <Bar data={data} options={options} />
    </div>
  )
}

export default ER_Chart2;